export default __webpack_public_path__ + "static/media/sa-17.55e6002a.png";